var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("pre", { pre: true }, [
        _c("code", { attrs: { "v-pre": "", class: "language-javascript" } }, [
          _c("span", { attrs: { class: "hljs-keyword" } }, [_vm._v("import")]),
          _vm._v(" FormCustomComponent "),
          _c("span", { attrs: { class: "hljs-keyword" } }, [_vm._v("from")]),
          _vm._v(" "),
          _c("span", { attrs: { class: "hljs-string" } }, [
            _vm._v("'Form.vue'")
          ]),
          _vm._v("\n"),
          _c("span", { attrs: { class: "hljs-keyword" } }, [_vm._v("export")]),
          _vm._v(" "),
          _c("span", { attrs: { class: "hljs-keyword" } }, [_vm._v("default")]),
          _vm._v(" {\n  "),
          _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v("methods")]),
          _vm._v(": {\n    formCustomComponent() {\n      "),
          _c("span", { attrs: { class: "hljs-keyword" } }, [_vm._v("this")]),
          _vm._v(".$dialog({\n        "),
          _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v("title")]),
          _vm._v(": "),
          _c("span", { attrs: { class: "hljs-string" } }, [
            _vm._v("'Send Product Menu'")
          ]),
          _vm._v(",\n        "),
          _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v("size")]),
          _vm._v(": "),
          _c("span", { attrs: { class: "hljs-string" } }, [_vm._v("'lg'")]),
          _vm._v(",\n        "),
          _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v("component")]),
          _vm._v(": FormCustomComponent,\n        "),
          _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v("accept")]),
          _vm._v(": {\n          "),
          _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v("label")]),
          _vm._v(": "),
          _c("span", { attrs: { class: "hljs-string" } }, [_vm._v("'Send'")]),
          _vm._v(",\n          callback(data) {\n            "),
          _c("span", { attrs: { class: "hljs-keyword" } }, [_vm._v("if")]),
          _vm._v("(!data) "),
          _c("span", { attrs: { class: "hljs-keyword" } }, [_vm._v("return")]),
          _vm._v("\n            alert("),
          _c("span", { attrs: { class: "hljs-string" } }, [
            _vm._v("`We had sent email to "),
            _c("span", { attrs: { class: "hljs-subst" } }, [_vm._v("${data}")]),
            _vm._v("`")
          ]),
          _vm._v(")\n          }\n        },\n      })\n    },\n  },\n}\n")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-379b7587", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-379b7587","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./src/Resource/Example/CustomeComponent/FormMain.md
// module id = null
// module chunks = 